import { Box, Pressable, Text } from '@rbilabs/universal-components';

import { getDesignToken, spacing } from 'styles/constants';
export const Tile = Box.withConfig(() => ({
  background: getDesignToken('background-pattern'),
  shadow: '1',
  borderRadius: '2xl',
  alignItems: 'center',
  minHeight: '$48',
  paddingX: '$4',
  paddingTop: '$1',
  paddingBottom: '$4',
  marginY: '$4',
  justifyContent: {
    md: 'space-between',
  },
  flexDirection: {
    md: 'row',
  },
}));

export const Col = Box.withConfig(() => ({
  width: {
    md: '48%',
    base: 'full',
  },
  marginBottom: {
    md: '$0',
  },
}));

export const MoreItems = Pressable.withConfig({
  paddingTop: spacing.$0_5,
  background: 'transparent',
});

export const MoreItemsText = Text.withConfig({
  color: getDesignToken('text-accent-order-number'),
  fontSize: 'sm',
});

export const FormattedDate = Text.withConfig({
  textTransform: getDesignToken('text-transform-headlines'),
  marginBottom: '$6',
});

export const SubtitleContainer = Text.withConfig(() => ({
  color: getDesignToken('text-default'),
}));

export const NumItems = Text.withConfig(() => ({
  marginLeft: '$1',
}));

export const Items = Box.withConfig(() => ({
  lineHeight: '16',
  paddingRight: '$4',
  margin: '$0',
}));

export const ItemNameContainer = Box.withConfig(() => ({
  alignItems: 'flex-start',
  marginBottom: '$6',
  color: getDesignToken('text-default'),
}));

export const Wrap = Box.withConfig(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  height: {
    md: 'auto',
  },
}));

export const OrderNumberWrapper = Box.withConfig(() => ({
  flexDirection: 'row',
  marginX: '$0',
  marginTop: '$4',
}));

export const OrderNumberText = Text.withConfig({
  fontSize: 'sm',
  fontWeight: '400',
});

export const OrderNumber = Text.withConfig({
  color: getDesignToken('text-accent-order-number'),
  fontSize: 'md',
  margin: '$0',
  paddingLeft: '$1',
});

export const OrderBox = Box.withConfig(() => ({
  marginTop: '$4',
  width: 'full',
}));

export const OrdersEmptyWrapper = Box.withConfig({
  minHeight: '2/3',
  paddingTop: '1/6',
  justifyContent: 'center',
});

export const OfferDisclaimer = Text.withConfig({
  textAlign: 'center',
  marginTop: '$3',
  paddingX: '$4',
  focusable: true,
});
